import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {getAccountManagerSettings, saveAccountManagerSettings} from 'src/openapi/admin/apis/AccountManagerSettingsControllerApi';
import {useAppDispatch} from 'src/store/hooks';

import type {SaveOptions} from 'src/components/save-with-reason/save-with-reason-button';
import type {AccountManagerSettings} from 'src/openapi/admin/models/AccountManagerSettings';

type Props = {
    userId: number,
};

export const useAccountTeamMemberSettings = ({userId}: Props) => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => apiDispatch(
        getAccountManagerSettings({accountManagerId: userId}),
    ), [userId, apiDispatch]);

    const saveDispatchAction = useCallback((
        accountManagerSettings: AccountManagerSettings,
        signal: AbortSignal,
        options?: SaveOptions,
    ) => apiDispatch(
        saveAccountManagerSettings({
            accountManagerId: userId,
            accountManagerSettingsSaveRequest: {...accountManagerSettings, reason: options?.reason},
        }, {signal}),
    ), [userId, apiDispatch]);

    return useCommonDataHook({
        getDispatchAction,
        saveDispatchAction,
        initValue: {accountManager: false},
    });
};
